import ApiCore from '../../../services/api/utilities/core'
import apiProvider from '../../../services/api/utilities/provider'

const url = 'agencies'
const plural = 'agencies'
const single = 'agency'

// plural and single may be used for message logic if needed in the ApiCore class.
const apiAgencies = new ApiCore({
  getAll: true,
  getSingle: true,
  post: true,
  put: false,
  patch: true,
  delete: false,
  url,
  plural,
  single,
})

apiAgencies.getPaginatedAgencyPositions = (id, { params }) =>
  apiProvider.getAll(`${url}/${id}/positions`, { params })

apiAgencies.createAgencyPosition = (id, data) =>
  apiProvider.post(`${url}/${id}/position`, data)

apiAgencies.editAgencyPosition = (agencyId, id, data) =>
  apiProvider.patch(url, `${agencyId}/position/${id}`, data)

apiAgencies.publishAgencyPosition = (agencyId, id, data) =>
  apiProvider.patch(url, `${agencyId}/position/${id}/publish`, data)

apiAgencies.getPositionsCountByAgency = () =>
  apiProvider.getAll(`${url}/position/count`)

apiAgencies.getCandidatesCountByAgency = () =>
  apiProvider.getAll(`${url}/local-candidate/count`)

apiAgencies.getInterviewsCountByAgency = () =>
  apiProvider.getAll(`${url}/interview/count`)

apiAgencies.getActiveOrganizationsCount = () =>
  apiProvider.getAll(`${url}/active-org/count`)

apiAgencies.matchPosition = (agencyId, data) =>
  apiProvider.post(`${url}/${agencyId}/applications`, data)

apiAgencies.getApplicationsByStage = (id, { params }) =>
  apiProvider.getAll(`${url}/${id}/applications`, { params })

apiAgencies.getPositionOrganizationId = (agencyId, positionId) =>
  apiProvider.getSingle(`${url}/${agencyId}/position`, positionId)

apiAgencies.createOrganizationsSubscriptionsCount = (id, data) =>
  apiProvider.post(`${url}/${id}/services-counter`, data)

apiAgencies.getOrganizationsSubscriptionsCount = (id, { params }) =>
  apiProvider.getAll(`${url}/${id}/subscriptions/count`, { params })

apiAgencies.getCandidate = (id) =>
  apiProvider.getSingle(url, `local-candidates/${id}`)

apiAgencies.getAgencyCandidate = (id) =>
  apiProvider.getSingle(url, `org-local-candidates/${id}`)

apiAgencies.getPaginatedAgencyCandidates = (id, { params }) =>
  apiProvider.getAll(`${url}/${id}/local-candidates`, { params })

apiAgencies.getApplicationByCandidate = (candidateId) =>
  apiProvider.getSingle(`${url}/applications/local-candidates`, candidateId)

apiAgencies.deleteOrgUser = (orgId, userId) =>
  apiProvider.instance.delete(`${url}/organizations/${orgId}/users/${userId}`)

/**
 * Get filtered organizations from the API.
 *
 * @param {object} params - The parameters for filtering organizations.
 * @return {Promise} A Promise that resolves with the filtered organizations data.
 */
apiAgencies.getFilteredOrgs = (params) =>
  apiProvider.getAll(`${url}/all`, { params })

/**
 * Updates an organization with the provided data.
 *
 * @param {object} params - The parameters for filtering organizations.
 * @return {Promise} A promise that resolves with the filtered organizations data
 */
apiAgencies.getOrgs = (params) => apiProvider.getAll(`${url}/companies`, params)

/**
 * Updates an organization with the provided data.
 *
 * @param {string} id - The ID of the organization
 * @return {Promise} A promise that resolves with the organization data
 */
apiAgencies.getOrg = (id) => apiProvider.getSingle(`${url}/companies`, id)

/**
 * Updates an organization with the provided data.
 *
 * @param {object} data - The data to update the organization with
 * @return {Promise} A promise that resolves with the updated organization data
 */
apiAgencies.addOrg = (data) => apiProvider.post(`${url}/companies`, data)

/**
 * Updates an organization with the provided data.
 *
 * @param {string} id - The ID of the organization
 * @param {object} data - The data to update the organization with
 * @return {Promise} A promise that resolves with the updated organization data
 */
apiAgencies.updateOrg = (id, data) =>
  apiProvider.patch(`${url}/companies`, id, data)

/**
 * Updates an organization with the provided data.
 *
 * @param {string} id - The ID of the organization
 * @return {Promise} A promise that resolves with the updated organization data
 */
apiAgencies.deleteOrg = (id) => apiProvider.remove(`${url}/companies`, id)

/**
 * Invites a user to an organization using the provided data.
 *
 * @param {Object} data - The data containing information about the user and the organization.
 * @return {Promise} A promise that resolves with the result of the invitation request.
 */
apiAgencies.inviteUserToOrg = (data) =>
  apiProvider.post(`${url}/invite-user-to-org`, data)

apiAgencies.updateApplication = (id, data) =>
  apiProvider.patch(`${url}/applications`, id, data)

apiAgencies.updateLogo = (data) => apiProvider.patch(url, 'logo', data)

apiAgencies.rejectApplications = (data) =>
  apiProvider.post(`${url}/applications/reject`, data)

apiAgencies.getActiveOrganizations = () =>
  apiProvider.getAll(`${url}/active-organizations`)

apiAgencies.uploadToPosition = (organizationId, data) =>
  apiProvider.post(
    `${url}/organizations/${organizationId}/upload-to-position`,
    data,
  )

apiAgencies.getOrganizationBranches = (organizationId) =>
  apiProvider.getAll(`${url}/organizations/${organizationId}/branches`)

export default apiAgencies
